import { Component, OnInit } from '@angular/core';
import { CMSPortalService } from '../shared/service/cms-portal.service';
import { Menu } from '../shared/model/menu.model';
import { Router } from '@angular/router';
import { NotificationService } from '../shared/messages/notification.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  public menus: Menu[] = [];

  constructor(private service: CMSPortalService, private router: Router, private log: NotificationService) { }

  ngOnInit() {
    this.getMenu();
  }

  getMenu() {
    this.service.getMenuSite().subscribe(res => {
      this.menus = res.conteudo;
    });
  }

  openItem(item: Menu) {
    this.router.navigate(['/pagina', item.cdPagina]);
  }

}
